var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgActiveChargeConnector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_882_36724)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.224 38.2354H50.3426C43.732 38.2354 38.373 43.603 38.373 50.2244V141.254C38.373 147.875 43.732 153.243 50.3426 153.243H141.224C147.835 153.243 153.194 147.875 153.194 141.254V50.2244C153.194 43.603 147.835 38.2354 141.224 38.2354Z",
    fill: "#E1FFF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2485 137.106C42.8913 137.419 42.5299 137.745 42.1557 138.058C40.3507 139.572 38.4522 140.986 36.7598 142.618C34.3128 144.977 33.5049 147.928 34.3234 151.248C35.2525 155.018 38.5542 157.784 42.4172 157.888C46.6693 158.003 50.9235 157.961 55.1777 157.961C84.7189 157.965 114.262 157.961 143.803 157.963C145.696 157.963 147.581 157.841 149.35 157.139C154.695 155.015 157.837 150.693 157.995 144.783C158.109 140.452 158.024 136.116 158.024 131.783C158.024 103.95 158.018 76.1155 158.035 48.283C158.035 46.0364 157.723 43.8665 156.802 41.8221C155.75 39.4903 154.121 37.6377 151.98 36.2088C149.539 34.5819 146.833 34.0367 143.969 34.0367C112.327 34.0367 80.6837 34.0388 49.0419 34.0367C47.0647 34.0367 45.0918 34.0687 43.1975 34.7075C38.7881 36.196 35.8138 39.1198 34.5785 43.6492C34.2171 44.9738 34.0088 46.3835 34.0066 47.7528C33.9747 74.7995 33.979 101.846 33.9981 128.893C33.9981 129.672 33.811 130.194 33.1754 130.697C31.128 132.315 29.1402 134.014 27.1332 135.684C26.8143 135.95 26.5124 136.238 26.1084 136.6C26.0702 136.284 26.017 136.048 26.017 135.814C26.0106 130.548 26.0085 125.281 26.0064 120.013C26.0064 95.9837 26.0149 71.9545 26 47.9253C25.9979 43.5598 26.9737 39.4903 29.3676 35.8063C31.8508 31.9839 35.2163 29.2539 39.4323 27.5162C42.2599 26.3471 45.2023 26.0064 48.2149 26.0064C80.2776 26.0043 112.34 26.0106 144.403 26C148.976 26 153.166 27.2223 156.908 29.8437C160.272 32.2011 162.748 35.3038 164.373 39.1006C165.514 41.7689 165.995 44.5543 165.995 47.4291C166.001 79.7974 166.001 112.166 165.997 144.534C165.997 151.819 162.923 157.577 157.18 161.932C154.752 163.772 151.98 164.969 149.002 165.59C147.707 165.861 146.357 165.982 145.032 165.982C111.069 166.004 77.1077 166.001 43.1443 165.997C38.0822 165.997 33.8153 164.074 30.3903 160.397C27.839 157.658 26.4231 154.355 26.0957 150.595C25.6598 145.575 27.1247 141.189 30.5157 137.502C31.719 136.195 33.1796 135.12 34.5403 133.959C35.6097 133.045 36.7131 132.172 37.7867 131.265C38.0844 131.014 38.2948 131.003 38.5521 131.318C40.0807 133.184 41.62 135.039 43.1528 136.898C43.1847 136.938 43.1975 136.994 43.2464 137.104L43.2485 137.106Z",
    fill: "url(#paint0_linear_882_36724)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.33 108.966C126.992 110.989 124.943 112.659 122.887 112.672C121.152 112.684 119.417 112.653 117.684 112.678C115.69 112.708 114.215 111.801 113.169 110.174C112.627 109.333 112.191 108.421 111.746 107.52C111.538 107.099 111.262 106.952 110.802 106.954C106.731 106.967 102.66 106.95 98.5905 106.975C98.1801 106.977 97.7103 107.107 97.3701 107.331C93.0139 110.204 88.6789 113.11 84.3333 116C79.79 119.022 75.2381 122.029 70.6927 125.05C68.3519 126.607 66.0218 128.179 63.6853 129.74C61.774 131.017 59.4587 130.745 57.9684 128.979C55.5532 126.117 53.1933 123.211 50.8015 120.329C50.2062 119.614 49.5812 118.922 48.9689 118.221C47.351 116.373 47.3361 114.075 49.0369 112.297C50.4741 110.793 52.0112 109.386 53.5037 107.934C57.3284 104.218 72.2043 89.8115 75.8228 86.3277C78.019 84.2131 80.162 82.0346 82.439 80.0073C85.3899 77.3817 88.7958 75.4587 92.5462 74.2428C95.731 73.21 99.0157 72.6201 102.39 72.6244C109.017 72.635 115.643 72.6372 122.27 72.6201C123.482 72.618 124.581 72.8863 125.549 73.6253C126.614 74.4387 127.283 75.4928 127.419 76.8387C127.498 77.6202 127.502 107.94 127.332 108.96L127.33 108.966Z",
    fill: "url(#paint1_linear_882_36724)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.652 106.962V76.0399C130.652 76.0399 138.32 76.0336 141.935 76.0399C144.199 76.0442 146.117 77.554 146.542 79.658C146.614 80.0136 146.629 80.3841 146.629 80.7483C146.629 88.0226 146.591 95.297 146.642 102.571C146.657 104.613 144.858 106.89 142.309 106.939C138.478 107.013 130.654 106.96 130.654 106.96L130.652 106.962Z",
    fill: "url(#paint2_linear_882_36724)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1512 46.5204C68.091 53.569 64.0112 66.8656 64.0112 66.8656C64.0112 66.8656 77.4328 66.8656 76.6653 66.8656C68.8883 75.8669 59.1511 85.0238 51.3741 94.0251C51.34 94.0081 51.3082 93.9932 51.2741 93.9762C53.6829 86.589 57.5438 73.7076 57.5438 73.7076H46.5225C54.4292 64.5615 70.0768 46.4629 70.0768 46.4629C70.0768 46.4629 70.1278 46.5012 70.1533 46.5204H70.1512Z",
    fill: "url(#paint3_linear_882_36724)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.383 131.895C56.383 131.895 54.2145 133.087 53.1578 133.654C51.778 134.395 50.3578 135.068 49.0163 135.873C47.6025 136.718 46.3141 136.154 45.5062 135.196C43.8012 133.173 42.128 131.124 40.442 129.086C39.2748 127.676 39.3514 126.213 40.6121 124.868C42.2577 123.109 43.8883 121.337 45.4956 119.542C45.8251 119.173 46.008 119.188 46.295 119.538C48.2063 121.865 54.0423 128.922 55.033 130.14C55.4688 130.677 56.3851 131.897 56.3851 131.897L56.383 131.895Z",
    fill: "url(#paint4_linear_882_36724)"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 18.5,
    y: 18.5,
    width: 155,
    height: 155,
    rx: 28.5,
    stroke: "#33E992",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 9.5,
    y: 9.5,
    width: 173,
    height: 173,
    rx: 33.5,
    stroke: "#33E992",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.05,
    x: 1.5,
    y: 1.5,
    width: 189,
    height: 189,
    rx: 39.5,
    stroke: "#33E992",
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_882_36724",
    x1: 96,
    y1: 26,
    x2: 96,
    y2: 166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26C579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2EDB88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_882_36724",
    x1: 87.6151,
    y1: 72.6201,
    x2: 87.6151,
    y2: 130.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26C579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2EDB88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_882_36724",
    x1: 138.647,
    y1: 76.0371,
    x2: 138.647,
    y2: 106.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26C579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2EDB88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_882_36724",
    x1: 61.6097,
    y1: 46.4629,
    x2: 61.6097,
    y2: 94.0251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26C579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2EDB88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_882_36724",
    x1: 47.9997,
    y1: 119.271,
    x2: 47.9997,
    y2: 136.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26C579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2EDB88"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_882_36724"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgActiveChargeConnector);
export default __webpack_public_path__ + "static/media/img_active_charge_connector.1e84abe2cbd7efda07a9f3df4035cc84.svg";
export { ForwardRef as ReactComponent };